export default __webpack_public_path__ + "static/media/space_object_03-min.752965df.png";